module.exports = __webpack_public_path__ + "static/media/paw.2cd39b64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ShowMoreTrigger/paw.svg
// module id = 334
// module chunks = 0